import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["Component", "size", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { ListSizeContext, useListSize } from "../ListSizeContext";
/*
 * Общий компонент для Ol, Ul, Dl. Принимает через проп Component компонент = UlStyled | OlStyled | DlStyled;
 * нужен для создания контекста
 */

var List = function List(_ref) {
  var Component = _ref.Component,
      sizeProperty = _ref.size,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var size = useListSize(sizeProperty);
  return /*#__PURE__*/React.createElement(Component, _extends({
    size: size
  }, props), /*#__PURE__*/React.createElement(ListSizeContext.Provider, {
    value: size
  }, children));
};

export default List;